var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:Object.assign({}, {btn: true,
        'btn--disabled': _vm.disabled,
        'btn--loading': _vm.loading},
        _vm._modifiers),attrs:{"disabled":_vm.disabled || _vm.loading,"type":_vm.type}},_vm.$listeners),[_vm._t("bg"),_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('Spinner',{staticClass:"current-color btn__spinner"}):_vm._e()],1),_c('span',{staticClass:"btn__inner",class:{ btn__loading: _vm.loading }},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }